/**
 * Clears held modifier key state by sending synthetic keyup events.
 * This ensures the Canvas library doesn't retain stale modifier key state
 * when the user leaves and re-enters the canvas area.
 *
 * Use case: User holds Control, leaves canvas, releases Control outside,
 * then re-enters canvas. Without this reset, the Canvas would still think
 * Control is held, causing unintended actions like duplication.
 */
export function clearModifierKeyState(): void {
  const modifierKeys = ['Control', 'Shift', 'Alt'];

  modifierKeys.forEach((key) => {
    const keyupEvent = new KeyboardEvent('keyup', {
      key,
      code: getCodeForKey(key),
      bubbles: true,
      cancelable: true,
    });

    document.dispatchEvent(keyupEvent);
  });
}

function getCodeForKey(key: string): string {
  const codeMap: Record<string, string> = {
    Control: 'ControlLeft',
    Shift: 'ShiftLeft',
    Alt: 'AltLeft',
  };

  return codeMap[key] || key;
}
